export default function (props: any) {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13 20H21.9375M13 29.6642H21.9375M26.0625 20H35M13 24.9627H21.9375M26.0625 30V25.619C26.0625 25.2565 26.3703 24.9627 26.75 24.9627H35"
                stroke="#83868A"
                strokeWidth="2.14286"
                strokeLinecap="round"
            />
            <circle cx="24" cy="24" r="18" stroke="#83868A" strokeWidth="2.14286" />
        </svg>
    );
}
